var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8916 4.10801C15.5666 3.78301 15.0416 3.78301 14.7166 4.10801L5.44161 13.383V7.13301C5.44994 6.67468 5.08328 6.29968 4.61662 6.29968C4.15828 6.29968 3.78328 6.67468 3.78328 7.13301L3.7666 15.0997C3.7666 15.3997 3.88328 15.6913 4.09161 15.8997C4.30828 16.1163 4.59161 16.233 4.89161 16.233L12.8583 16.2163C13.3166 16.2163 13.6916 15.8413 13.6916 15.383C13.6916 14.9247 13.3166 14.5497 12.8583 14.5497H6.60827L15.8833 5.28301C16.2083 4.95801 16.2083 4.43301 15.8833 4.10801H15.8916Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownLeft);
export default __webpack_public_path__ + "static/media/arrow-down-left.268bf9e2a14e4b60f61ea0e9223f1032.svg";
export { ForwardRef as ReactComponent };